import React, { useState } from "react";
import Select from "react-select";

const MultiInput: React.FC<any> = (props: any) => {
  const [inputValue, setInputValue] = useState("");
  /** Code to handle all the event based logics to bind and remove select all */
  const onChange = (newValue: any, actionMeta: any) => {
    const { action, removedValue } = actionMeta;

    if (action === "remove-value" && removedValue.value) {
      let ds: Array<any> = [];
      if (props.selectedItems.length) {
        ds = props.selectedItems.filter(
          ({ value }: any) => value !== removedValue.value
        );
      }
      props.setSelectedItems(ds);
    } else if (actionMeta.action === "clear") {
      props.onAllRemove();
    } else {
      props.setSelectedItems(newValue || []);
    }

    if (props?.onChange) {
      props.onChange(newValue, actionMeta);
    }
  };

  const onInputChange = (newValue, actionMeta) => {
    setInputValue(newValue);
  };

  // Function to handle when the enter key is pressed
  const onKeyDown = (event) => {
    if (event.key === "Enter" && inputValue) {
      event.preventDefault();

      // Create a new option with the current input value
      const newOption = { label: inputValue, value: inputValue };

      // Update the selected items state
      const newSelectedItems = [...props.selectedItems, newOption];
      props.setSelectedItems(newSelectedItems);

      // Clear the input value
      setInputValue("");
    }
  };

  return (
    <Select
      id={props.id}
      isMulti={true}
      options={props.options}
      inputValue={inputValue}
      value={props.selectedItems}
      onChange={onChange}
      closeMenuOnSelect={true}
      onKeyDown={onKeyDown}
      onInputChange={onInputChange}
      menuPortalTarget={document.body}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: "#B3B3B3",
          primary: "#041E42",
        },
      })}
      styles={{
        control: (base, state) => ({
          ...base,
          background:
            document.getElementsByClassName("dark")?.length > 0
              ? "#1A1C23"
              : "white",
          borderColor:
            document.getElementsByClassName("dark")?.length > 0
              ? "#6B7280"
              : "#D1D5DB",
          borderWidth: "1px",
          "&:hover": {
            borderColor:
              state.isFocused &&
              document.getElementsByClassName("dark")?.length > 0
                ? "#6b7280"
                : state.isFocused
                ? "#4c5563"
                : "",
          },
        }),
        singleValue: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0
              ? "white"
              : "#374051",
        }),
        input: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0 ? "white" : "",
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
      noOptionsMessage={(e) => (e.inputValue ? null : null)}
    ></Select>
  );
};

export default MultiInput;
